import { render, staticRenderFns } from "./languaje-skills.vue?vue&type=template&id=5aba9ea4&scoped=true&"
var script = {}
import style0 from "./languaje-skills.vue?vue&type=style&index=0&id=5aba9ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba9ea4",
  null
  
)

export default component.exports